import { defineStore } from "pinia";
import { ref } from "vue";

export const useDateFormatStore = defineStore("dateFormatStore", () => {
    const globalDateFormat = ref<string>("DD.MM.YYYY");
    const globalDateTimeFormat = ref<string>("YYYY-MM-DDTHH:mm:ss[Z]");
    const globalTimeZone = ref<string>("Europe/Berlin");

    return { globalDateFormat, globalDateTimeFormat, globalTimeZone };
});
